import React from 'react';
import { Link } from 'react-router-dom';
import BenefitBox from '../components/BenefitBox';
import businessAnalysis from '../images/business-analysis-icon.svg';
import productOnwer from '../images/product-owner-icon.svg';
import scrumMaster from '../images/scrum-master-icon.svg';
import jesseVanDijk from '../images/jesseVanDijk.png';  // New import

const services = [
    {
      title: "Business Analyse",
      description: "Als Business Analist vertaal ik complexe vraagstukken naar concrete oplossingen. Door de behoeften van eindgebruikers centraal te stellen, creëer ik heldere documentatie en processen die direct toepasbaar zijn. Mijn pragmatische aanpak zorgt voor duidelijke requirements en effectieve communicatie tussen alle betrokkenen.",
      image: businessAnalysis
    },
    {
      title: "Product Owner",
      description: "Als Product Owner ben ik de brug tussen business en development. Ik vertaal strategische doelen naar concrete user stories, maak heldere keuzes in prioriteiten en zorg voor maximale waarde in elke sprint. Met focus op gebruikersbehoeften en stakeholder alignment creëer ik producten die écht impact maken.",
      image: productOnwer
    },
    {
      title: "Scrum Master",
      description: "Als Scrum Master faciliteer ik teams naar succes. Ik coach organisaties in het praktisch toepassen van Agile principes, verwijder impediments en stimuleer continue verbetering. Door heldere communicatie en pragmatische oplossingen help ik teams groeien en resultaten behalen.",
      image: scrumMaster
    }
];

const Home = () => {
  return (
    <main>
      <section className="hero">
        <div className="hero-content">
          <h1>Pragmatische Agile Professional: Van Complexiteit naar Duidelijkheid</h1>
          <p>Als interim Business Analist, Product Owner en Scrum Master help ik organisaties met het implementeren van werkende Agile oplossingen en digitale producten. Focus op eindgebruikers, transparante stakeholdercommunicatie en praktische documentatie voor blijvend resultaat.</p>
          <div className="hero-buttons">
            <Link to="over-ons" className="btn-primary">Over ons</Link>
            <Link to="contact" className="btn-secondary">Contact</Link>
          </div>
        </div>
        <div className="hero-image">
          <img src={jesseVanDijk} alt="Jesse van Dijk" />
        </div>
      </section>

      {/* Rest of the component remains the same */}
      <section className="diensten" id="diensten">
        <h2>Diensten</h2>
        <div className="diensten-grid">
          {services.map((service, index) => (
            <div key={index} className="dienst-card">
              <img src={service.image} alt={service.title} className="dienst-icon" />
              <div className="dienst-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <Link to="/diensten" className="btn-primary">Meer</Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="why-choose-section">
        <div className="why-choose-grid">
          <div className="why-choose-left">
            <div className="sticky-content">
              <h2 className="orange-text">Een partner in verandering</h2>
              <h1 className="blue-title">
                Complexe uitdagingen<br />
                omzetten naar<br />
                duurzame<br />
                oplossingen<span className="blue-dot">.</span>
              </h1>
            </div>
          </div>
          <div className="why-choose-right">
            <BenefitBox
              title="Verbinding tussen Business & IT"
              description="Als ervaren Agile professional verbind ik business en IT door heldere communicatie en wederzijds begrip. Mijn achtergrond in beide werelden stelt mij in staat om technische complexiteit te vertalen naar bedrijfswaarde, en bedrijfsbehoeften om te zetten in concrete oplossingen."
            />
            <BenefitBox
              title="Pragmatische Agile Aanpak"
              description="Ik geloof in het praktisch toepassen van Agile principes, aangepast aan de context van uw organisatie. Door mijn hands-on ervaring help ik teams om complexe uitdagingen behapbaar te maken en tastbare resultaten te behalen, zonder de flexibiliteit uit het oog te verliezen."
            />
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;